import { createSelector } from '@reduxjs/toolkit';

import { PaymentStates } from '@cashier/cashier-model';

import {
  PaymentInfoState,
  PAYMENTS_DATA_FEATURE_KEY,
} from './paymentInformation.slice';

export const getPaymentInfoState = (rootState: any): PaymentInfoState =>
  rootState[PAYMENTS_DATA_FEATURE_KEY];

export const selectPaymentCurrentState = createSelector(
  getPaymentInfoState,
  (s) => (s.paymentInfo?.state as PaymentStates) || null,
);
